import ProductSpecifications, {
  Table,
} from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';

const Wrapper = styled('div')`
  width: 100%;
  margin: 2rem auto;
  max-width: 800px;
  ${Table} {
    ul {
      list-style-type: none;
      margin-left: 0;
      display: flex;
      li:not(:last-child) {
        margin-right: 5px;
        &:after {
          content: ',';
          margin: 0 2px;
        }
      }
    }
    tr th {
      min-width: 150px;
    }
    tr:nth-of-type(2n-1) {
      //background: ${theme.colors.greys[1]};
    }
    tbody > tr {
      background: none;
      border-bottom: 1px solid ${theme.colors.border};
      height: 40px;
      ${theme.above.md} {
        &:nth-of-type(2n + 1) {
        }
      }
    }
  }
`;

export const ProductSpecificationsWrapper = ({
  className,
  fields,
  title = false,
}) => {
  if (!fields || fields.length === 0) return null;
  return (
    <Wrapper>
      {title && <h3>{title}</h3>}
      <ProductSpecifications className={className} fields={fields} />
    </Wrapper>
  );
};
